import type { Distance, Rectangle } from "@pdfking/math"
import { Min, Scale } from "@pdfking/math"

// The measures a page of `width` × `height` is set in: its shortest side, a
// margin of a tenth of it and a body text size of a thirty-second
export const PageMetrics = ({ height, width }: Rectangle<Distance>) => {
  const short = Min(width, height)
  return { font_size: Scale(short, 0.03125), margin: Scale(short, 0.1), short }
}
